import Header from "../Header";
import Footer from "../Footer";
import Breadcrumbs from "../Breadcrumbs";
import BannerImg from "../assets/Images/banner-1920x450.png";

import BottomLogoImg from "../assets/Images/bottom-logo.png";
import LineImg from "../assets/Images/line.png";
import TitleImg from "../assets/Images/title.png";
import "./ArbitrationFeesPage.scss";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Table from "react-bootstrap/Table";

const ArbitrationFeesPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <Header />
      <div className="banner">
        <img src={BannerImg} alt="" />
        <div className="banner_title res">
          <h1 className="banner-main-title">
            {t("arbitration_fees_page_header")}
          </h1>
          <p className="banner-subtitle">
            {t("arbitration_fees_page_header2")}
          </p>
        </div>
      </div>
      <Breadcrumbs>
        <Link>{t("breadcrumbs_arbitration_fees_page_link1")}</Link>
        <span>{t("breadcrumbs_arbitration_fees_page_span")}</span>
        <Link>{t("breadcrumbs_arbitration_fees_page_link2")}</Link>
      </Breadcrumbs>
      <main className="fees-main-container">
        <section className="fees-content-section">
          <div className="fees-title-container">
            <img src={TitleImg} alt="Title icon" className="fees-title-icon" />
            <h2 className="fees-section-title">
              {t("arbitration_fees_page_h3")}
            </h2>
          </div>
          <div className="fees-text-container">
            <p className="fees-paragraph">
              {t("arbitration_fees_page_text1")}
              <span>
                <sup>#1</sup>
              </span>
            </p>
          </div>
          <div className="fees-table-container">
            <Table className="fees-table" striped responsive>
              <thead id="t-head">
                <tr>
                  <th>{t("arbitration_fees_page_text2")}</th>
                  <th>
                    <p className="mb-3">{t("arbitration_fees_page_text3")}</p>
                    <p className="mb-3">{t("arbitration_fees_page_text4")}</p>
                  </th>
                </tr>
              </thead>
              <tbody id="t-body">
                <tr>
                  <td>{t("arbitration_fees_page_text5")}</td>
                  <td>$9,000 #2</td>
                </tr>
                <tr>
                  <td>{t("arbitration_fees_page_text6")}</td>
                  <td>$25,000 #2</td>
                </tr>
                <tr>
                  <td>{t("arbitration_fees_page_text7")}</td>
                  <td>$50,000</td>
                </tr>
                <tr>
                  <td>{t("arbitration_fees_page_text8")}</td>
                  <td>$80,000</td>
                </tr>
                <tr>
                  <td>{t("arbitration_fees_page_text9")}</td>
                  <td>$120,000</td>
                </tr>
                <tr>
                  <td>{t("arbitration_fees_page_text10")}</td>
                  <td>$240,000</td>
                </tr>
                <tr>
                  <td>{t("arbitration_fees_page_text14")}</td>
                  <td>$480,000</td>
                </tr>
              </tbody>
            </Table>
          </div>
          <div className="fees-notes-section">
            <h3 className="fees-notes-title">
              {t("arbitration_fees_page_text11")}
            </h3>
            <p className="fees-paragraph">
              {t("arbitration_fees_page_text12")}
            </p>
            <p className="fees-paragraph">
              {t("arbitration_fees_page_text13")}
            </p>
          </div>
        </section>
        {/* <div className="fees-divider">
          <img src={LineImg} alt="Decorative line" className="divider-line" />
        </div> */}
      </main>

      <div className="temporary">
        <img src={BottomLogoImg} alt="" className="bottom-logo" />
      </div>
      <Footer />
    </>
  );
};

export default ArbitrationFeesPage;
